import React, { useEffect } from 'react';
import styles from './LeftBar.module.scss';
import { useAllIssuesNodePage } from 'modules/website/hooks/useAllIssuesNodePage';
import { PulseLoader } from 'react-spinners';
import { FaLinkSlash } from 'react-icons/fa6';

const LeftBar = ({ title }) => {
    const { isLoading, isError, payload, error } = useAllIssuesNodePage();
    const [links, setLinks] = React.useState([]);
    useEffect(() => {
        if (payload) {
            // Do something with the payload if needed
            // Push at the end of the array { view_taxonomy_term: "/category/Issues", name: "See more", showMore: true }
            const updatedLinks = [...payload.data];
            updatedLinks.push({ view_taxonomy_term: "/category/Issues", name: "See more", showMore: true });
            setLinks(updatedLinks);

        }
    }, [payload]);

    return (

        <div className={styles.left_bar}>
            {isLoading && <div
                className={'d-flex justify-content-center align-items-center'}
            >
                <PulseLoader
                    loading={true}
                    size={5}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div>
            }
            {isError && <div>{error}</div>}
            {!isLoading && !isError && payload && (
                <>
                    <div className={styles.left_bar_title}>{title}</div>
                    <div style={{ width: '80%', backgroundColor: '#000', height: '1px' }}></div>
                    <ul className={styles.left_bar_content}>
                        {links.map((link, index) => (
                            <li key={index} className={link.showMore ? styles.more : ""}>
                                <a href={link.view_taxonomy_term.replace('/api/glifos','')} target="_self" className={link.showMore ? styles.moreLink : ""}>
                                    {link.name}
                                </a>
                            </li>

                        ))}
                    </ul>
                </>
            )}
        </div>
    );
}

export default LeftBar;
